import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'
import { useBucket } from '@mc/experiments-react'

const HP_TESTIMONIALS_EXP_FLAG = 'pen-5386_v1'

export const useTrackHPTestimonialsExperimentViewed = () => {
  useEffect(() => {
    trackExperimentViewed(HP_TESTIMONIALS_EXP_FLAG)
  }, [])
}

export const useHPTestimonialsExperiment = () => {
  const bucket = useBucket(HP_TESTIMONIALS_EXP_FLAG)

  const showNewTestimonials = bucket?.startsWith('variant')
  const showMobileCarousel = bucket === 'variant_1'

  return {
    showNewTestimonials,
    showMobileCarousel,
  }
}
